import styled from 'styled-components'

export const MenuWrapper = styled.div`
  color: #2b313a;
  font-size: 1.6rem;
  font-weight: 600;
  line-height: normal;
  position: relative;
`

export const MenuContainer = styled.div`
  cursor: pointer;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;

  background-color: white;
  border: 1px solid #d8d9dc;
  border-radius: 1.6rem;
  //min-height: 4.8rem;
  min-width: 14rem;
  padding: 1.2rem 1.6rem;

  .arrow {
    margin: 0 0 0 10px;
    width: 8px;
  }
`

export const MenuDropDown = styled.div`
  z-index: 1001;
  position: absolute;

  top: 5rem;
  right: 0;

  width: auto;
  min-width: 14rem;
  padding: 1rem 0;
  white-space: nowrap;
  font-weight: normal;

  background-color: white;
  border-radius: 1rem;
  box-shadow: 0 5px 30px rgba(172, 182, 191, 0.25);

  display: none;
  &.opened {
    display: block;
  }

  ul {
    margin: 0;
    padding: 0;
    list-style: none;

    & > li {
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: flex-start;

      height: 3rem;
      color: #454a54;
      padding: 0 2rem;

      :hover {
        background: #eff3f8;
      }
    }
  }
`
